module.exports = __webpack_public_path__ + "static/media/logo-innovate.3080a75d.png";